import {VGSidebar} from "vgnav/src/VGSidebar";

$(document).on('submit', '#cart-offer', function () {
	let route = $(this).attr('action');
	let params = $(this).serializeArray();

	let $btn = $(this).find('button[type=submit]');

	VegasCatalog.Cart.setCartState('order-loading');

	$.post(route, params, function (data) {
		if (data.error) {
			VegasCatalog.Cart.setCartState('order');
		} else {
			VegasCatalog.Cart.setCartState('offer-success');
		}
	});

	return false;
})
